import { ConfigurationResult } from '@mews-distributor/data-access';
import { createAction } from '@mews/framework/redux';
import {
    FETCH_CONFIGURATION_FAILED,
    FETCH_CONFIGURATION_STARTED,
    FETCH_CONFIGURATIONS_FAILED,
    FETCH_CONFIGURATIONS_STARTED,
    FETCH_CONFIGURATIONS_SUCCEEDED,
} from '../../modules/configuration/actionTypes';
import { getConfigurationOrHotelIds } from '../../modules/configuration/selectors';
import { DistributorPromiseThunkAction } from '../../types';

export const getConfiguration =
    (): DistributorPromiseThunkAction<ConfigurationResult> =>
    async (dispatch, getState, { apiService }) => {
        const state = getState();
        const ids = getConfigurationOrHotelIds(state);
        dispatch(createAction(FETCH_CONFIGURATION_STARTED));
        dispatch(createAction(FETCH_CONFIGURATIONS_STARTED));

        return apiService
            .getConfigurations({ ids, primaryId: ids[0] })
            .then((configurationsResponse) => {
                dispatch(createAction(FETCH_CONFIGURATIONS_SUCCEEDED, configurationsResponse));

                return configurationsResponse;
            })
            .catch((error) => {
                dispatch(createAction(FETCH_CONFIGURATION_FAILED, { error }));
                dispatch(createAction(FETCH_CONFIGURATIONS_FAILED, { error }));

                throw error;
            });
    };
